import { consumer } from '@tock/coretypes';
import { getLocality } from 'utils/businessUtils';

export function getTitleSuffix(
  business?: consumer.OfferingBusiness | consumer.BusinessConfig | consumer.IBusinessConfig | null
) {
  if (!business) {
    return '';
  }
  const locality = getLocality(business);
  return locality ? ` - ${locality}` : '';
}
